<template>
  <base-show
    :fields="isProvider ? providerFields : makerFields"
    :resourceName="resourceName"
    :pk="pk"
    :breadcrumbs="breadcrumbs"
    @check-maker="checkMaker"
  />
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const vm = this;
    let reviewItemFields = [];

    for (let i=1; i<=11; i++) {
      let props = {
        label: i === 11 ? "必須" : `質問${i}`,
        name: `review_item_name_${i}`,
        long: true,
        type: "display-reviewset"
      };
      reviewItemFields.push(props)
    }

    let commonFields = [
      {
        label: "テンプレートID",
        name: "template_id",
        long: true
      },
      {
        label: "テンプレート名",
        name: "template_name",
        long: true
      }
    ];

    const makerFields = [
      [
        ...commonFields,
        ...reviewItemFields
      ]
    ];

    const providerFields = [
      [
        {
          label: "メーカーID",
          name: "maker_id",
          long: true
        },
        {
          label: "メーカー名",
          name: "maker_name",
          long: true
        },
        ...commonFields,
        ...reviewItemFields
      ]
    ];

    return {
      resourceName: "templates",
      providerFields: providerFields,
      makerFields: makerFields
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "レビューテンプレート一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "レビューテンプレート詳細",
          disabled: true
        }
      ];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  },
  methods: {
    checkMaker(entity) {
      this.$router.push({ path: `/makers/${entity.maker_id}` });
    }
  },
  created() {
    this.$store.dispatch(`templates/entity/updateAnswerItem`);
  }
};
</script>
